import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { getLatestEnrolmentCalendar } from '../../../services/vu'
import Error from '../../pages/Error'
import Loading from '../../pages/Loading'
import { getCourseId } from '../../../helpers/course'
import { getAttributeCourseStaticInfo } from '../../../helpers/enrolment'

class EnrolmentIsClosed extends Component {
  constructor(props) {
    super(props)
  }

  enrolOpen() {
    if (getAttributeCourseStaticInfo('isEnrolOpen') === 'Y') {
      return true
    }
    return false
  }

  render() {
    if (!this.enrolOpen()) {
      return (
        <Error
          title="Enrolment is not open"
          description={
            <p>
              Enrolment has not yet opened for this course. We will notify you
              by email and via <a href="https://myvu.edu.au">MyVU</a> once it
              has.
            </p>
          }
        />
      )
    }

    return this.props.children
  }
}

export default withRouter(EnrolmentIsClosed)
